module.exports = __webpack_public_path__ + "img/upload-file.7b259053.svg";